import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectPolicy from "../../../components/modals/customers/create/SelectPolicy";
import ModalContainer from "../../../components/modals/ModalContainer";
import PaginationLinks from "../../../components/pagination/PaginationLinks";
import PageTitle from "../../../components/partials/PageTitle";
import { getAttachPolicyCustomer } from "../../../redux/slice/customer/customerSlice";
import { resetAttachedPolicyPreview } from "../../../redux/slice/policy/policySlice";
import { policyAttachmentCategories } from "../../../utils/data/constant";
import {
  resetPolicy,
  resetTempData,
} from "../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";

const PolicyAttachmentSearch = () => {
  const [searchBy, setSearchBy] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [Id, setId] = useState(null);
  const { user } = useSelector((state) => state?.auth?.user);
  const { attachPolicy_customer } = useSelector((state) => state?.customer);

  const dispatch = useDispatch();

  const handleSearchBy = (e) => {
    e.preventDefault();
    if (searchBy) {
      dispatch(
        getAttachPolicyCustomer({
          search: searchBy,
          office_id: user?.office_id,
          page: pageNumber,
        })
      );
    }
  };

  const fetchPolicyCustomer = async (pageNumber) => {
    setPageNumber(pageNumber);
    dispatch(
      getAttachPolicyCustomer({
        search: searchBy,
        office_id: user?.office_id,
        page: pageNumber,
      })
    );
  };

  useEffect(() => {
    dispatch(resetAttachedPolicyPreview());
    dispatch(resetPolicy());
  }, []);

  const breadcrumb = {
    from: {
      title: "Applied Policies",
      link: "/admin/applied-policies",
    },
    current: {
      title: "policy attachment",
      link: null,
    },
  };
  return (
    <>
      <PageTitle title='Policy Attachment' breadcrumb={breadcrumb} back />
      <div className='card p-2'>
        <div className='row py-2'>
          <div className='col-md-4 col-lg-4'>
            <h4>Search for Customer</h4>
            <form
              onSubmit={handleSearchBy}
              className='d-flex align-items-center '
              // ref={searchCorp}
            >
              <input
                type='search'
                value={searchBy}
                className=' form-control form-control-sm'
                placeholder='Search...'
                onChange={(e) => setSearchBy(e.target.value)}
                style={{
                  height: "28px",
                  marginLeft: "1px",
                  outline: "none",
                }}
              />
              <button
                type='submit'
                className='btn btn-primary btn-sm d-flex align-items-center gap-1'
              >
                Search
              </button>
            </form>
          </div>
        </div>
        {attachPolicy_customer && (
          <div className='row'>
            <div className='col-sm-12 table-responsive mt-3 '>
              <table
                className={`table table-centered table-striped no-footer ${
                  attachPolicy_customer?.data?.length < 1 && "row"
                }`}
              >
                <thead>
                  <tr>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "120.8px" }}
                      aria-label='Customer: activate to sort column ascending'
                    >
                      Customer Id
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "144.8px" }}
                      aria-label=''
                    >
                      Customer Name
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label=''
                    >
                      Office
                    </th>
                    <th style={{ width: "85.8px" }} className='text-center'>
                      Action
                    </th>
                  </tr>
                </thead>

                {attachPolicy_customer?.data?.length ? (
                  <tbody>
                    {attachPolicy_customer?.data?.map((item, i) => (
                      <tr key={i}>
                        <td className='text-capitalize'>{item?.customerId}</td>
                        <td className='text-capitalize'>
                          {item?.customerFirstName} {item?.customerLastName}
                        </td>
                        <td className='text-capitalize'>{item?.officeName}</td>
                        <td className='p-0 text-center'>
                          <button
                            data-bs-toggle='modal'
                            data-bs-target='#select-policy'
                            className='btn btn-primary btn-sm '
                            onClick={() => setId(item.id)}
                          >
                            Select
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <div className=''>
                    <h5 className='alert alert-info'>Result not found!</h5>
                  </div>
                )}
              </table>
            </div>
            <ModalContainer modal_id='select-policy' modal_width='modal-sm'>
              <SelectPolicy id={Id} categories={policyAttachmentCategories} />
            </ModalContainer>
          </div>
        )}
        {attachPolicy_customer?.data?.length ? (
          <div className='row mt-1'>
            <div className='col-sm-12 col-md-6'>
              <div
                className='dataTables_info table-pages'
                id='products-datatable_info'
                role='status'
                aria-live='polite'
              >
                Showing offices {attachPolicy_customer?.from} to{" "}
                {attachPolicy_customer?.to} of {attachPolicy_customer?.total}
              </div>
            </div>

            <div className='col-sm-12 col-md-6'>
              <PaginationLinks
                paginationData={attachPolicy_customer}
                getNextPage={fetchPolicyCustomer}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default PolicyAttachmentSearch;
